import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

const usePreChatDafaplusStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      minHeight: 'calc(100vh - 64px)',
      backgroundColor: '#eef2f7',
      boxSizing: 'border-box',
      '@media (max-width:425px)': {
        minHeight: '100vh',
      },
    },
    pageBody: {
      width: '100%',
      maxWidth: '100%',
      margin: 0,
      padding: 0,
    },
    hero: {
      width: '100%',
      backgroundColor: '#930102',
      color: '#ffffff',
      padding: '28px 24px 64px',
      borderBottomLeftRadius: '24px',
      borderBottomRightRadius: '24px',
      boxSizing: 'border-box',
      '@media (max-width:425px)': {
        padding: '20px 18px 40px',
      },
    },
    heroTitle: {
      fontWeight: '700 !important',
      fontSize: '22px !important',
      lineHeight: '1.25 !important',
      color: '#ffffff',
      textAlign: 'center' as const,
    },
    searchWrap: {
      marginTop: '-18px',
      padding: '0 24px',
      position: 'relative',
      zIndex: 1,
    },
    searchField: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '999px',
        backgroundColor: '#ffffff',
        boxShadow: '0 10px 22px rgba(14, 24, 42, 0.12)',
        '@media (max-width:425px)': {
          minHeight: '40px',
        },
      },
      '& .MuiInputBase-input': {
        '@media (max-width:425px)': {
          paddingTop: '8px',
          paddingBottom: '8px',
          fontSize: '13px',
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
    content: {
      padding: '16px 24px 24px',
      boxSizing: 'border-box',
      position: 'relative' as const,
      height: 'calc(100vh - 250px)',
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '90px',
      '@media (max-width:425px)': {
        height: 'calc(100vh - 35px)',
      },
    },
    faqList: {
      display: 'grid',
      gap: '14px',
      marginBottom: '10px',
      overflowY: 'auto',
      flex: 1,
      minHeight: 0,
    },
    faqCard: {
      backgroundColor: '#ffffff',
      borderRadius: '20px',
      padding: '18px 18px 16px',
      boxShadow: '0 6px 18px rgba(27, 39, 51, 0.08)',
      border: '1px solid #e4ebf3',
      cursor: 'pointer',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: '0 10px 24px rgba(27, 39, 51, 0.12)',
      },
      '@media (max-width:425px)': {
        padding: '12px 12px 10px',
      },
    },
    faqTitle: {
      fontWeight: '700 !important',
      fontSize: '14px !important',
      color: '#121826',
      marginBottom: '8px !important',
    },
    faqDescription: {
      fontSize: '12px !important',
      color: '#667085',
      lineHeight: '1.45 !important',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical' as const,
      '& p': {
        margin: '0 0 10px',
      },
      '& p:last-child': {
        marginBottom: 0,
      },
      '& ul, & ol': {
        margin: '0 0 10px',
        paddingLeft: '18px',
      },
      '& li': {
        marginBottom: '6px',
      },
      '& li:last-child': {
        marginBottom: 0,
      },
      '& strong': {
        color: '#344054',
      },
    },
    faqDescriptionExpanded: {
      display: 'block',
      overflow: 'visible',
      WebkitLineClamp: 'unset' as const,
      WebkitBoxOrient: 'unset' as const,
    },
    emptyState: {
      textAlign: 'center' as const,
      color: '#667085',
      padding: '20px 0',
    },
    primaryCta: {
      width: '100%',
      backgroundColor: '#930102 !important',
      color: '#ffffff !important',
      fontWeight: '700 !important',
      fontSize: '16px !important',
      lineHeight: '2 !important',
      borderRadius: '999px !important',
      padding: '11px 18px !important',
      textTransform: 'none' as const,
      boxShadow: 'none !important',
      '&:hover': {
        backgroundColor: '#7a0102 !important',
        boxShadow: 'none !important',
      },
    },
    faqPrimaryCta: {
      position: 'static' as const,
      width: '100% !important',
      maxWidth: '100%',
      marginTop: '16px',
      boxShadow: 'none !important',
      '@media (max-width:425px)': {
        minHeight: '28px !important',
        fontSize: '11px !important',
        fontWeight: '500 !important',
        padding: '4px 12px !important',
      },
    },
    heroQuestion: {
      fontWeight: '600 !important',
      fontSize: '24px !important',
      lineHeight: '30px !important',
      color: '#fff',
      '@media (max-width:425px)': {
        fontWeight: '500 !important',
        fontSize: '19px !important',
        lineHeight: '24px !important',
      },
    },
    categoryContent: {
      padding: '20px 20px 20px',
      boxSizing: 'border-box',
      minHeight: 'calc(100vh - 10px)',
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '96px',
    },
    languageSelectorWrap: {
      marginBottom: '14px !important',
      '& .MuiInputLabel-root': {
        color: '#f8d2d2',
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: '#ffffff',
      },
      '& .MuiFormHelperText-root': {
        marginLeft: 0,
      },
      '& .MuiInputBase-root': {
        borderRadius: '14px',
        backgroundColor: '#930102',
        color: '#ffffff',
        minHeight: '44px',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.2)',
      },
      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.45)',
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ffffff',
      },
      '& .MuiFormHelperText-root.Mui-error': {
        color: '#b42318',
      },
    },
    languageSelectorLabel: {
      color: '#f8d2d2 !important',
    },
    languageSelector: {
      color: '#ffffff !important',
      '& .MuiSelect-icon': {
        color: '#ffffff',
      },
      '& .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
        minHeight: '44px',
        paddingTop: '6px',
        paddingBottom: '6px',
      },
    },
    languageOptionItem: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
    },
    languageOptionFlag: {
      fontSize: '20px',
      lineHeight: 1,
      width: '30px',
      height: '30px',
      borderRadius: '999px',
      backgroundColor: '#ffffff',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: 'inset 0 0 0 1px rgba(16, 24, 40, 0.06)',
    },
    languageOptionTextMuted: {
      color: '#ffd7d7',
      fontSize: '15px',
    },
    languageMenuPaper: {
      backgroundColor: '#7d0000 !important',
      borderRadius: '12px !important',
      marginTop: '6px',
    },
    languageMenuList: {
      padding: '4px !important',
    },
    languageMenuItem: {
      borderRadius: '8px !important',
      color: '#ffffff !important',
      minHeight: '44px !important',
      '&:hover': {
        backgroundColor: '#a20404 !important',
      },
      '&.Mui-selected': {
        backgroundColor: '#b20a0a !important',
      },
      '&.Mui-selected:hover': {
        backgroundColor: '#bf1010 !important',
      },
    },
    categoryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '10px',
      marginBottom: 'auto',
    },
    categoryButton: {
      minHeight: '90px',
      borderRadius: '18px !important',
      color: '#ffffff !important',
      fontWeight: '700 !important',
      fontSize: '14px !important',
      textTransform: 'none' as const,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      boxShadow: 'none !important',
      transition: 'background-color 0.16s ease',
      '&:hover': {
        boxShadow: 'none !important',
      },
    },
    categoryIcon: {
      fontSize: '24px',
      lineHeight: 1,
    },
    depositButton: {
      background: 'linear-gradient(135deg, #8f5af7 0%, #6d42c9 100%) !important',
    },
    withdrawalButton: {
      background: 'linear-gradient(135deg, #1590d8 0%, #0f7ac7 100%) !important',
    },
    betButton: {
      background: 'linear-gradient(135deg, #168a82 0%, #0e6f6b 100%) !important',
    },
    bonusButton: {
      background: 'linear-gradient(135deg, #d5167c 0%, #bb126d 100%) !important',
    },
    bottomAction: {
      marginTop: 'auto',
    },
  })
);

export default usePreChatDafaplusStyles;
